export const loadHelpers = {
  loadItems: ({ids, fetchFn, setMap, key, idKey = 'id'} = {}) => {
    // remove duplicates from ids
    ids = Array.isArray(ids) ? [...new Set(ids)] : [];

    if (ids.length) {
      fetchFn?.({
        data: { [key]: ids },
        successCallback: (response) => {
          // response can be or array or object or can be {results: []}
          const responseData = Array.isArray(response) ? response : response.results;
          if (responseData) {
            setMap(prevMap =>
              responseData.reduce((map, item) => {
                map[item[idKey]] = item;
                return map;
              }, {...prevMap})
            );
          }
        }
      });
    }
  }
}
